import type { NumberInputProps } from "@mantine/core";
import { NumField } from "./NumField";

/**
 * Currency entry: a NumField that knows it is rupees.
 *
 * Indian digit grouping comes from Mantine's thousandSeparator plus the
 * grouping rule below - ₹2,84,500, not ₹284,500. Getting that wrong does not
 * merely look foreign; a lakh misread as a hundred thousand is a real
 * misreading in a shop that deals in both.
 *
 * DISPLAY of an amount is a different job and already has a home: rupees() in
 * lib/money.ts, which formats with Intl "en-IN". There is deliberately no
 * second formatter here - the brief asked for a formatINR(), and this codebase
 * already had it under another name.
 */
export function MoneyField(props: NumberInputProps) {
  return (
    <NumField
      prefix="₹"
      thousandSeparator=","
      // Indian grouping: 3 digits, then 2s. Mantine takes the group sizes
      // directly, so this is the whole of it.
      thousandsGroupStyle="lakh"
      decimalScale={2}
      {...props}
    />
  );
}
